import { useTranslation } from "react-i18next";

import frog from "@/assets/brand/studio-frog.png";
import { cn } from "@/lib/cn";

/** Discreet credit for the studio that built the archive. `compact` shows only the logo. */
export function StudioSignature({ compact = false, className }: { compact?: boolean; className?: string }) {
  const { t } = useTranslation();
  const label = `${t("studio.craftedBy")} ${t("studio.name")}`;
  return (
    <div
      className={cn(
        "flex items-center gap-2 text-xs text-ink-subtle",
        compact && "justify-center",
        className,
      )}
      title={compact ? label : undefined}
    >
      <img src={frog} alt={compact ? label : ""} width={20} height={20} className="size-5 opacity-90" />
      {!compact && (
        <span>
          {t("studio.craftedBy")} <span className="font-medium text-ink-muted">{t("studio.name")}</span>
        </span>
      )}
    </div>
  );
}
